// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fp-3";
export var downloadButton = "_fp-4";
export var fileContainer = "_fp-9 _fp-7";
export var fileContainerBase = "_fp-7";
export var fileContainerFixedHeight = "_fp-8 _fp-7";
export var fileInfo = "_fp-5";
export var fileInfoWidthRestricted = "_fp-6";
export var fileType = "_fp-1";
export var fileTypeName = "_fp-2";
export var image = "_fp-0";
export var link = "_fp-b";
export var overflowEllipsis = "_fp-a";